/* tslint:disable */
/* eslint-disable */
/**
 * Probonio full API Docs
 * If you stumbled upon this page and want to integrate Probonio into your business software [click here!](/api/external)    If you\'re looking for more information about Probonio [head over here](https://probonio.de)    **This documentation describes all Endpoints of the Probonio API. It\'s created for experienced Probonio Developers only!**   <a href=\"http://localhost:4100/mock-idp/realms/probonio/protocol/openid-connect/logout\" target=\"_blank\"><button>     <h4>Click here to trigger a full logout from Keycloak.</h4> </button></a><br /> 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { UpdateCarSettingsDTO } from '../dto';
// @ts-ignore
import { ValidationErrorResponseDTO } from '../dto';
/**
 * CarApi - axios parameter creator
 * @export
 */
export const CarApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary update the car company code of a tenant
         * @param {string} tenantId 
         * @param {UpdateCarSettingsDTO} updateCarSettingsDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCarSettings: async (tenantId: string, updateCarSettingsDTO: UpdateCarSettingsDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('updateCarSettings', 'tenantId', tenantId)
            // verify required parameter 'updateCarSettingsDTO' is not null or undefined
            assertParamExists('updateCarSettings', 'updateCarSettingsDTO', updateCarSettingsDTO)
            const localVarPath = `/tenants/{tenantId}/benefits/car/settings`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCarSettingsDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CarApi - functional programming interface
 * @export
 */
export const CarApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CarApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary update the car company code of a tenant
         * @param {string} tenantId 
         * @param {UpdateCarSettingsDTO} updateCarSettingsDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCarSettings(tenantId: string, updateCarSettingsDTO: UpdateCarSettingsDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCarSettings(tenantId, updateCarSettingsDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CarApi - factory interface
 * @export
 */
export const CarApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CarApiFp(configuration)
    return {
        /**
         * 
         * @summary update the car company code of a tenant
         * @param {string} tenantId 
         * @param {UpdateCarSettingsDTO} updateCarSettingsDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCarSettings(tenantId: string, updateCarSettingsDTO: UpdateCarSettingsDTO, options?: any): AxiosPromise<void> {
            return localVarFp.updateCarSettings(tenantId, updateCarSettingsDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for updateCarSettings operation in CarApi.
 * @export
 * @interface CarApiUpdateCarSettingsRequest
 */
export interface CarApiUpdateCarSettingsRequest {
    /**
     * 
     * @type {string}
     * @memberof CarApiUpdateCarSettings
     */
    readonly tenantId: string

    /**
     * 
     * @type {UpdateCarSettingsDTO}
     * @memberof CarApiUpdateCarSettings
     */
    readonly updateCarSettingsDTO: UpdateCarSettingsDTO
}

/**
 * CarApi - object-oriented interface
 * @export
 * @class CarApi
 * @extends {BaseAPI}
 */
export class CarApi extends BaseAPI {
    /**
     * 
     * @summary update the car company code of a tenant
     * @param {CarApiUpdateCarSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarApi
     */
    public updateCarSettings(requestParameters: CarApiUpdateCarSettingsRequest, options?: AxiosRequestConfig) {
        return CarApiFp(this.configuration).updateCarSettings(requestParameters.tenantId, requestParameters.updateCarSettingsDTO, options).then((request) => request(this.axios, this.basePath));
    }
}
